<template>
  <div class="product">
    <div class="product__preview">
      <a @click="handleClick" :href="product.link" :title="product.title">
        <picture>
          <source :srcset="product.image.webp" type="image/webp" />
          <img
              :alt="product.title"
              :src="product.image.source"
              class="product__image"
              loading="lazy"
          />
        </picture>
      </a>

      <h3 class="product__title">
        <a @click="handleClick" :href="product.link" :title="product.title">
          {{ product.title }}
        </a>
      </h3>

      <div :class="product.stock_status_class" class="product__status">
        {{ product.stock_status }}
      </div>

      <product-price :prices="product.prices" class-name="product__price" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductLandingItem",
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleClick(event) {
      window.location.href = this.product.link;
    },
  },
};
</script>
